import type { GradeType } from '../types/entities'
import i18n from 'i18next'
import { localIsoDate, parseLocalDate } from './dates.ts'

/** Цвет фона/текста для бейджа оценки. */
export function gradeColor(value: string): string {
  const n = parseFloat(value)
  if (isNaN(n)) {
    if (value === 'зач' || value === 'зачёт') return 'bg-green-100 text-green-800'
    if (value === 'нзч' || value === 'незачёт') return 'bg-red-100 text-red-800'
    return 'bg-gray-100 text-gray-700'
  }
  if (n >= 5) return 'bg-green-100 text-green-800'
  if (n >= 4) return 'bg-blue-100 text-blue-800'
  if (n >= 3) return 'bg-yellow-100 text-yellow-800'
  return 'bg-red-100 text-red-800'
}

/** «Вс / Пн / Вт / …». */
export function dayOfWeek(iso: string): string {
  // 'yyyy-MM-dd' — локальная дата (new Date(iso) дал бы UTC-полночь и в
  // отрицательных таймзонах предыдущий день недели)
  const d = parseLocalDate(iso) ?? new Date(iso)
  return [
    i18n.t('gradeFormatters.sun'),
    i18n.t('gradeFormatters.mon'),
    i18n.t('gradeFormatters.tue'),
    i18n.t('gradeFormatters.wed'),
    i18n.t('gradeFormatters.thu'),
    i18n.t('gradeFormatters.fri'),
    i18n.t('gradeFormatters.sat'),
  ][d.getDay()]
}

/** Локализованная дата для tooltip. */
export function formatDate(iso: string): string {
  return (parseLocalDate(iso) ?? new Date(iso)).toLocaleDateString('ru')
}

/** Человекочитаемая метка типа оценки. */
export function gradeTypeLabel(t: GradeType): string {
  return {
    current: i18n.t('gradeFormatters.typeCurrent'),
    test: i18n.t('gradeFormatters.typeTest'),
    exam: i18n.t('gradeFormatters.typeExam'),
    project: i18n.t('gradeFormatters.typeProject'),
    homework: i18n.t('gradeFormatters.typeHomework'),
    term: i18n.t('gradeFormatters.typeTerm'),
    year: i18n.t('gradeFormatters.typeYear'),
  }[t] ?? t
}

/** Last N дней включая сегодня — список ISO дат «yyyy-mm-dd». */
export function lastNDates(periodDays: number, today: Date = new Date()): string[] {
  const out: string[] = []
  for (let i = periodDays - 1; i >= 0; i--) {
    const d = new Date(today)
    d.setDate(d.getDate() - i)
    out.push(localIsoDate(d))
  }
  return out
}
